import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import dayjs from 'dayjs';

class Component extends BaseComponent {
    render({ state_upc, coins, price, percent, upc }) {
        const kc_sale_start = dayjs('2019-02-24 00:00:01');
        const kc_sale_end = dayjs('2019-02-24 23:59:59');
        const now = dayjs();
        const kc_sale = now.isAfter(kc_sale_start) && kc_sale_end.isAfter(now);

        return (
            <standard-package className={state_upc === upc ? 'selected' : ''}>
                <label>
                    <row>
                        <column className='is-2'>
                            <div className={`pseudo-radio ${state_upc === upc ? 'checked' : ''}`}>
                                <input
                                    type='radio'
                                    name='upc'
                                    value={upc}
                                    checked={state_upc == upc}
                                    onChange={() => this.trackChange(upc)}
                                />
                            </div>
                        </column>
                        <column className='is-1'>
                            <div className='icon-karma-coin' />
                        </column>
                        <column className='is-6'>
                            <h4>
                                {coins} <span>Karma Coins</span>
                            </h4>
                            <h6>${price}</h6>
                        </column>
                        <column className='is-3'>
                            {this.renderDiscountAmount(percent, kc_sale)}
                        </column>
                    </row>
                </label>
            </standard-package>
        );
    }

    renderDiscountAmount(percent, kc_sale) {
        if (parseInt(percent, 10) > 0 && kc_sale == false) {
            return (
                <h5>
                    <b>{percent}</b>
                    <br />
                    OFF
                </h5>
            );
        }

        return null;
    }

    trackChange = (upc) => {
        let label = 'logged-out';
        if (this.props.logged_in) {
            label = this.props.sale_price_code == 'first-time-buyer' ? '1st-kc-package' : '2nd-or-more-kc-package';
        }

        this.props.trackEvent([ 'kc-store', `Click-${upc}`, label ]);
        this.props.setUPC(upc);
    }
}

const mapStateToProps = (state) => ({
    logged_in: state.user && state.user.logged_in,
    sale_price_code: state['karmacoin-store'].packages && state['karmacoin-store'].packages.standard[0].sale_price_code,
    state_upc: state['karmacoin-store'] && state['karmacoin-store'].upc,
});

const mapDispatchToProps = (dispatch) => ({
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
    setUPC: (upc) => dispatch({ type: 'karmacoin-store:update', payload: { upc: upc } }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
